module.exports = __webpack_public_path__ + "static/img/stim-img.330c8488.png";